"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_188)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_188`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359863 0.000305176H35.6402V23.9998H-0.359863V0.000305176Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359863 0.000305176H35.6402V4.80005H-0.359863V0.000305176ZM-0.359863 9.5998H35.6402V14.3995H-0.359863V9.5998ZM-0.359863 19.2001H35.6402V23.9998H-0.359863V19.2001Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.6402 12.0005L-0.359863 24.0002V-0.00012207L17.6402 12.0005Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.5097 7.72028L6.57191 10.9897H10.0098L7.22863 13.0104L8.29084 16.2798L5.5097 14.2592L2.72849 16.2798L3.79091 13.0104L1.00977 10.9897H4.44749L5.5097 7.72028Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_188`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PRFlag };
